import * as t from 'io-ts';
import { isLeft } from 'fp-ts/Either';

const formData = (type: t.Decoder<unknown, unknown>) =>
  new t.Type<FormData>(
    'FormData',
    (value): value is FormData => value instanceof FormData,
    (value, ctx) => {
      if (value instanceof FormData) {
        const plainObject = Object.fromEntries(value.entries());
        const validation = type.validate(plainObject, ctx);

        if (isLeft(validation)) {
          return validation;
        }

        return t.success(value);
      }

      return t.failure(value, ctx, 'value is not instance of FormData');
    },
    raw => raw,
  );

export { formData };
